import { CheckField } from './checkField/CheckField';
import { CustomSelectField, LegacyCustomSelectField } from './customSelectField/CustomSelectField';
import { DateField } from './dateField/DateField';
import { ThemeSelectField } from './themeSelectField/ThemeSelectField';
import { RadioField } from './radioField/RadioField';
import { LegacySelectField } from './legacySelectField/LegacySelectField';
import { SelectField } from './selectField/SelectField';
import { TextField } from './textField/TextField';
import { TextAreaField } from './textAreaField/TextAreaField';
import { IconTextField } from './iconTextField/IconTextField';
import { UrlField } from './urlField/UrlField';
import { LanguageSelectField } from './languageSelectField/LanguageSelectField';
import { OrderField } from './orderField/OrderField';

export { EditableLabelField } from './editableLabelField/EditableLabelField';
export { PlayAudioButton } from './playAudioButton/PlayAudioButton';
export { ProgressiveUploadButton } from './progressiveUploadButton/ProgressiveUploadButton';
export { ListSelectField } from './listSelectField/ListSelectField';

const LegacyDateField = TextField; // TODO: upgrade all legacy sites to the new DateField
const TimeField = TextField; // TODO: actually create a TimeField control

export {
    CheckField,
    CustomSelectField,
    LegacyCustomSelectField, // KILL
    DateField,
    LegacyDateField, // KILL
    IconTextField,
    ThemeSelectField,
    LanguageSelectField,
    RadioField,
    SelectField,
    LegacySelectField,
    TextField,
    TextAreaField,
    TimeField,
    UrlField,
    OrderField,
};
